var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 17.25H11.75M6.25 17.25V12.6667M6.25 17.25H1.3C1.15413 17.25 1.01424 17.1921 0.911091 17.0889C0.807946 16.9858 0.75 16.8459 0.75 16.7V13.2167C0.75 13.0708 0.807946 12.9309 0.911091 12.8278C1.01424 12.7246 1.15413 12.6667 1.3 12.6667H6.25M11.75 17.25V6.25M11.75 17.25H16.7C16.8459 17.25 16.9858 17.1921 17.0889 17.0889C17.1921 16.9858 17.25 16.8459 17.25 16.7V1.3C17.25 1.15413 17.1921 1.01424 17.0889 0.911091C16.9858 0.807946 16.8459 0.75 16.7 0.75H12.3C12.1541 0.75 12.0142 0.807946 11.9111 0.911091C11.8079 1.01424 11.75 1.15413 11.75 1.3V6.25M11.75 6.25H6.8C6.65413 6.25 6.51424 6.30795 6.41109 6.41109C6.30795 6.51424 6.25 6.65413 6.25 6.8V12.6667",
    stroke: "black",
    strokeWidth: 1.375
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.b61c6566744ed75365ae562df42169c6.svg";
export { ForwardRef as ReactComponent };